export default {
  MuiList: {
    styleOverrides: {
      root: {
        backgroundColor: 'none !important'
      },
      padding: {
        paddingBottom: '0px',
        paddingTop: '0px'
      }
    }
  },
  MuiListItem: {
    styleOverrides: {
      root: {
        width: '100%',
        padding: '0px',
        paddingRight: '4px',
        paddingLeft: '4px',
        paddingTop: '0px',
        paddingBottom: '0px',
        marginBottom: '8px',
        transition: 'ease-in-out 0.4s',
        backgroundColor: 'none !important',
        '&.Mui-selected': {
          backgroundColor: '#D9D9D9 !important',
          color: '#000000 !important',
          borderRadius: '4px'
        },
        '&$selected:hover': {
          transition: 'ease-in-out 0.4s',
          fontWeight: 'bold !important',
          background: '#D9D9D9 !important',
          color: '#000000',
          borderRadius: '4px'
        },
        '&:hover': {
          transition: 'ease-in-out 0.4s',
          fontWeight: 'bold !important',
          background: '#D9D9D9',
          color: '#000000',
          borderRadius: '4px'
        }
      },
      container: {
        margin: '8px 0px'
      },
      button: {
        width: '100%',
        height: 'auto'
      },
      dense: {
        paddingTop: '0px',
        paddingBottom: '0px'
      }
    }
  },
  MuiListItemText: {
    styleOverrides: {
      multiline: {
        marginTop: '0px',
        marginBottom: '0px'
      },
      primary: {
        fontSize: '16px'
      }
    }
  },
  MuiListItemAvatar: {
    styleOverrides: {
      root: {
        minWidth: '39px'
      }
    }
  }
};
